"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePriceOverrideRuleSchema = exports.createPriceOverrideRuleSchema = exports.priceOverrideScopeTypeEnum = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (OP Billing Administration, Module 3 — Price Override Rules). */
exports.priceOverrideScopeTypeEnum = zod_1.z.enum(['GLOBAL', 'DEPARTMENT', 'CHARGE_CATEGORY']);
const priceOverrideRuleBaseShape = {
    name: zod_1.z.string().min(1).max(255),
    scopeType: exports.priceOverrideScopeTypeEnum,
    scopeId: zod_1.z.string().uuid().optional(),
    maxOverridePercent: zod_1.z.number().min(0).max(100),
    requiresApproval: zod_1.z.boolean().optional(),
    approvalMatrixId: zod_1.z.string().uuid().optional(),
};
exports.createPriceOverrideRuleSchema = zod_1.z
    .object(priceOverrideRuleBaseShape)
    .refine((data) => data.scopeType === 'GLOBAL' || Boolean(data.scopeId), {
    message: 'scopeId is required unless scopeType is GLOBAL',
    path: ['scopeId'],
});
exports.updatePriceOverrideRuleSchema = zod_1.z.object(priceOverrideRuleBaseShape).partial();
//# sourceMappingURL=price-override-rule.schema.js.map